/**
 * Typisierter Zugriff auf die VITE_*-Umgebungsvariablen (build-time).
 */
export const env = {
  tenantId: import.meta.env.VITE_TENANT_ID,
  spaClientId: import.meta.env.VITE_SPA_CLIENT_ID,
  apiScope: import.meta.env.VITE_API_SCOPE,
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:5180',
} as const;
